module.exports = __webpack_public_path__ + "static/media/italian-5000.093dd2e5.png";